import React, { memo } from 'react';
import { formatTime } from '../../utils/formatters';

interface TimerDisplaysProps {
  mainTime?: number;
  lapTime?: number;
  segmentTime?: number;
  isRunning?: boolean;
  title?: string;
}

const TimerDisplays: React.FC<TimerDisplaysProps> = memo(
  ({ mainTime = 0, lapTime = 0, segmentTime = 0, isRunning = false, title = '' }) => {
    // Use the running/stopped state as a modifier class
    const stateModifier = isRunning ? 'running' : 'stopped';

    return (
      <div className="stopwatch__display-container">
        {/* Display title only if provided and not empty */}
        {title && title.trim() !== '' && <h3 className="stopwatch__title">{title}</h3>}

        {/* Main timer display - larger font and more prominent */}
        <div
          className={`stopwatch__display stopwatch__display--main stopwatch__display--${stateModifier} stopwatch__display--large`}
          data-testid="main-timer"
        >
          {formatTime(mainTime)}
          <div className="stopwatch__display-label">Total Time</div>
        </div>

        {/* Lap and Segment Timers in same row */}
        <div className="stopwatch__time-row">
          <div
            className={`stopwatch__display stopwatch__display--lap stopwatch__display--${stateModifier} stopwatch__display--medium`}
            data-testid="lap-timer"
          >
            {formatTime(lapTime)}
            <div className="stopwatch__display-label">Lap Time</div>
          </div>

          <div
            className={`stopwatch__display stopwatch__display--segment stopwatch__display--${stateModifier} stopwatch__display--medium`}
            data-testid="segment-timer"
          >
            {formatTime(segmentTime)}
            <div className="stopwatch__display-label">Segment Time</div>
          </div>
        </div>
      </div>
    );
  }
);

// Add display name
TimerDisplays.displayName = 'TimerDisplays';

export default TimerDisplays;
